"use strict";

const Button = require("app/shared/components/Button/button");
const Icon = require("app/shared/components/Icon/icon");
const Tooltip = require("app/shared/components/Tooltip/tooltip");

const CopyBox = React.createClass({
  propTypes: {
    text: React.PropTypes.string.isRequired
  },

  copyText: function() {
    this.input.select();
    document.execCommand("copy");
  },

  showTooltip: function() {
    this.tooltip.show(() => {
      setTimeout(() => { this.tooltip.hide(); }, 1000);
    });
  },

  handleClick: function() {
    this.copyText();
    this.showTooltip();
  },

  render: function() {
    return (
      <div className="input-group">
        <input
          type="text" ref={input => this.input = input}
          className="form-control" readOnly
          value={this.props.text}
        />
        <div className="input-group-btn">
          <Tooltip ref={tooltip => this.tooltip = tooltip} title="Copiado!" trigger="manual" color="green">
            <Button type="gray" className="btn-input-group form-control" onClick={this.handleClick}>
              <Icon custom icon="copy" />
            </Button>
          </Tooltip>
        </div>
      </div>
    )
  }
});

module.exports = CopyBox;



// WEBPACK FOOTER //
// ./app/shared/components/CopyBox/copy-box.jsx